module.exports = function() {
  return new Worker(__webpack_public_path__ + "9dcb2e1cc3ad94a71182.worker.js");
};